<template>
  <v-container>
    <v-col>
      <h2>Verze ROBisu a informace o nich</h2>
      <br>

      <h3>Chystáme:</h3>
      <li>Rozšíření online výsledků o vytvoření závodníka v etapě, pokud se odesílá výsledek a závodník není v etapě přihlášený</li>
      <li>Zpracování výkonnostních tříd na základě výsledků ze závodů (podmínkou jsou výsledky v databázi robisu - zatím je nikdo kromě GBM a FPA nenahrává)</li>



      <!-- <br><br>
      <h3>Známé chyby:</h3>
      <li>Optimalizace načítání přihlašování na soutěže</li> -->

      <br><br> 
      <!-- Verze a její popis se píše do samostatného js souboru tak aby mohl být importován do footru a ve versionPage -->
      <div v-for="version in versions" :key="version.version">
        <h3>verze {{ version.version }}</h3>
        <h5>{{ version.date }}</h5>
          <li v-for="note in version.notes" :key="note">{{ note }}</li>
        <br>
      </div>

    </v-col>
  </v-container>
</template>

<script setup>
import { versions } from '../composables/version.js';

</script>



<style scoped>

h3 {
        color:red;
    }




</style>
